<template>
  <div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card border-variant="primary" id="_share">
          <div slot="header" v-if="is_show">
            <strong>Partner Invoice Info</strong>
            <b-button size="sm" class="float-right" variant="success" @click="share"> Export </b-button>
          </div>
          <!-- <b-row>
            <b-col sm="12" class="text-center">
              <p style="font-size: 80px; font-weight: bold; text-decoration: underline;">INVOICE</p>
            </b-col>
          </b-row> -->
          <b-row>
            <vcl-facebook v-if="loading"></vcl-facebook>
            <b-col sm="12" v-else>
              <!-- <img v-if="model.is_paid" width="200" :src="'img/pay_clear.png'" alt="F1security" :style="pay_clear_css"> -->
              <!-- here code from the template body start -->
              <body style="size: 21cm 29.7cm; background-color:white;">
                <div id="body" style="margin: 10px; background-color:white;">
                  <center id="header" style="margin: 0px auto; width:80%;">
                    <img style="float: left;" src="F1-uwss.png" alt="partner logo" width="200">
                    <!-- <img style="padding-top:200px;" src=" {{ model.logo }}" alt="partner logo" width="200"> -->
                    <p style="text-decoration:underline; font-weight: bold; margin: 0; font-size: 80px; width: fit-content;">
                      INVOICE
                    </p>
                  </center>

                  <div style="margin-top:50px; text-align:center;">

                    <p style="text-align: right; width:88%; font-weight: bold; margin:0;">
                      Information Security Solution & Service Company
                    </p>

                    <div style="display:inline-block; width:40%; min-height: 350px;">
                      <table style="border-collapse: collapse; width:95%;">
                        <tbody>
                          <tr>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">Payer <br> Name </td>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{ model.partner.username }}</td>
                          </tr>
                          <tr>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">Payer <br> Address </td>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{ model.partner.address || '-' }}</td>
                          </tr>
                          <tr>
                            <td style="border: 2px solid black; padding:2px; height: 60px; width:10%;">Invoice <br> Number </td>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{ model.invoice_id }}</td>
                          </tr>
                          <tr>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">Total <br> Amount </td>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{ model.total_price - model.total_partner_price }} {{ model.currency }}</td>
                          </tr>
                          <tr>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">Validity </td>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">Within 4 weeks after estimated</td>
                          </tr>
                          <tr>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">Issue <br> Date </td>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{  model.created_at | datetime }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div style="display:inline-block; width:40%; min-height:350px;">
                      <table style="border-collapse: collapse; width:95%; margin: 0 auto;">
                        <tbody>
                          <tr>
                            <td style="border: 2px solid black; padding:2px; height: 45px;">Company <br> Name </td>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;"> {{ model.bill_custom.company || '-' }} </td>
                          </tr>
                          <tr>
                            <td style="border: 2px solid black; padding:2px; height: 45px;">Company <br> Address </td>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;">
                              {{ model.bill_custom.company_address || '-' }}
                            </td>
                          </tr>
                          <tr>
                            <td style="border: 2px solid black; padding:2px; height: 60px;">
                              Business Registration Number
                            </td>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;">{{ model.bill_custom.business_number  || '-' }}</td>
                          </tr>
                          <tr>
                            <td style="border: 2px solid black; padding:2px; height: 45px;"> Issuer </td>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;"> {{ model.bill_custom.issuer  || '-' }} </td>
                          </tr>
                          <tr>
                            <td style="border: 2px solid black; padding:2px; height: 45px;">Email </td>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;"> {{ model.bill_custom.issuer_email  || '-' }} </td>
                          </tr>
                          <tr>
                            <td style="border: 2px solid black; padding:2px; height: 45px;"> TEL </td>
                            <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;"> {{ model.bill_custom.contact  || '-' }} </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br>

                    <div style="display:inline-block; width:80%; text-align:left;">
                      <h2 style="padding-left: 15px;">
                        Billing period:  {{ model.start_at }} -  {{ model.end_at }}
                      </h2>
                      <p style="padding-left: 50px;">
                        Thank you for joining the partnership program with F1 Security, Inc.
                        <br>
                        We're writing to provide you with an electronic invoice for your end users of UWSS.
                        <br>
                        Additional information about this invoice, please access the partner console site and check the billing page.
                      </p>
                    </div>
                  </div>
                  <p style="text-align: right; width:90%; font-weight: bold; margin:0;">
                    ( {{ model.currency || '-' }} )
                  </p>
                  <div style="margin: 0 auto; text-align:center; font-weight: bold; width: 80%;">
                    <table style="border: 4px solid black; border-collapse: collapse; border-spacing: 0;">
                      <tr style="background-color: gainsboro; width:100%;">
                        <th style="padding: 5px; border: 2px solid black; width: 50%;">End User</th>
                        <th style="padding: 5px; border: 2px solid black; width: 18%;">Srv. <br> Type</th>
                        <th style="padding: 5px; border: 2px solid black; width: 12%;">Quantity <br> Used</th>
                        <th style="padding: 5px; border: 2px solid black; width: 18%;">Amount</th>
                        <th style="padding: 5px; border: 2px solid black; width: 5%;">REMARKS</th>
                      </tr>
                      <!-- <tr v-for="(item, id) in model.group_list_cache" v-bind:key="id">
                        <td style="border-top: black solid 1px; padding:5px;">{{ item.groupname }} </td>
                        <td style="border-top: black solid 1px; padding:5px;">{{ item.total_usage }} </td>
                        <td style="border-top: black solid 1px; padding:5px;">{{ item.base_price }} </td>
                        <td style="border-top: black solid 1px; padding:5px;">{{ item.discount_price }} </td>
                        <td style="border-top: black solid 1px; padding:5px;">{{ item.total_price }} </td>
                        <td style="border-top: black solid 1px; padding:5px;">
                            <b-badge variant="danger">WEBCastle : {{item.wc_usage | number}} </b-badge>
                            <b-badge variant="warning">WSFinder : {{item.wsf_usage | number}} </b-badge>
                            <b-badge variant="success">WMDS : {{item.wmds_usage | number}} </b-badge>
                            <b-badge variant="info">WFDetector : {{item.wf_usage | number}} </b-badge>
                        </td>
                      </tr> -->
                      <tr v-for="(x, id) in model.group_list_cache" v-bind:key="id">
                        <td style="padding: 5px; border-top: black solid 2px; width: 55%;"> {{ x.groupname }}</td>
                        <td style="border: black solid 2px; width: 18%;"> {{ x.service_name }}</td>
                        <td style="border: black solid 2px; width: 12%;"> {{ x.total_usage }}</td>
                        <!-- 에프원 제공 가격에서 파트너의 이익 뺀 가격임 -->
                        <td style="border: black solid 2px; width: 18%;"> {{ x.total_price - x.partner_price }}</td>
                        <td style="border: black solid 2px; width: 5%;">
                          {{ x.total_price == 0 ? '✓' : '' }}
                        </td>
                      </tr>
                      <tr>
                        <td style="background-color: gainsboro; padding: 5px; border: black solid 2px; width: 78%;" colspan="3">Charges (Total)</td>
                        <td style="padding: 5px; border: black solid 2px; width: 18%;"> {{ model.total_price - model.total_partner_price }}</td>
                        <td style="padding: 5px; border: black solid 2px; width: 5%;">  VAT Included </td>
                      </tr>
                    </table>
                    <span style="float: left; padding-top:5px;">(*1) When calculating the daily usage fee, one month is 30 days</span>
                    <br>
                    <div style="margin-top:50px;" v-if="model.bill_custom">
                      <span style="float:left">Payment Means: Please, pay to F1 Security Inc.’s designated Bank account</span>
                      <table style="border: 4px solid black; border-collapse: collapse; border-spacing: 0; width: 100%;">
                        <tr>
                          <th style="padding: 5px; border: 2px solid black; width: 15%;">Bank Name</th>
                          <th style="padding: 5px; border: 2px solid black; width: 45%;"> {{ model.bill_custom.bank_name || '-' }} </th>
                          <th style="padding: 5px; border: 2px solid black; width: 20%;">  Swift Code </th>
                          <th style="padding: 5px; border: 2px solid black; width: 20%;"> {{ model.bill_custom.swift_code || '-' }} </th>
                        </tr>
                        <tr>
                          <td style="border: black solid 2px; width: 15%;"> Account No. </td>
                          <td style="border: black solid 2px; width: 45%;"> {{ model.bill_custom.bank_number }}</td>
                          <td style="border: black solid 2px; width: 20%;">  Account Holder </td>
                          <td style="border: black solid 2px; width: 20%;"> {{ model.bill_custom.account_holder || '-' }} </td>
                        </tr>
                        <tr>
                          <td style="padding: 5px; border-top: black solid 2px; width: 15%;"> Bank branch </td>
                          <td style="border: black solid 2px;" colspan="3"> {{ model.bill_custom.bank_branch || '-' }} </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div id="footer">
                  <img style="float:right; margin-top:50px;" :src="model.logo" alt="partner logo" width="200" v-if="model.logo">
                  <img style="float:right; margin-top:50px; margin-right:10%;" src="img/F1security.png" alt="partner logo" width="200" v-else>
                </div>
              </body>
              <!-- here code from the template body end  -->
            </b-col>
          </b-row>

          <!-- 아래는 이전 버전 -->
          <!-- <b-row style="height:250px;">
            <b-col md="6">
              <b-form-group>
                <h4 for="ph_partner_name">Partner Summary</h4>
                <label class="ml-3" >Account</label>
                <p v-if="model.partner" class="ml-3">
                  {{model.partner.username}}
                </p>
                <hr>
                <label class="ml-3" >More Information</label>
                <p v-if="model.partner" class="ml-3">
                  Country : [{{model.partner.country}}] / Langague : [{{model.partner.language}}]
                </p>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <h4 for="ph_partner_name">Invoice Summary</h4>
                <label class="ml-3 w-100 pr-5" >Invoice Number : <span class="float-right">{{ model.invoice_id }}</span> </label>
                <label class="ml-3 w-100 pr-5" >Invoice Date : <span class="float-right">{{ model.created_at | sdate }}</span> </label>
                <hr>
                <label class="ml-3 w-100 pr-5" >Total Amount : <span class="float-right"> {{model.unit || '$'}} {{ model.total_price + model.total_paid }}</span> </label>
              </b-form-group>
              <hr>
                <p class="text-center">
                  <img class="text-center" width="200" :src="model.partner.logo || 'img/F1-uwss.png'" alt="Hello, F1security">
                </p>
            </b-col>
          </b-row> -->
          <hr>
          <!-- <b-row>
            <b-col md="12">
              <table style="width: 100%; text-align: center; border-collapse: collapse; border-spacing: 0;">
                <tr style="background-color: gainsboro;">
                  <td style="border-top: black solid 1px; padding:5px;"> Group(Coustmer) </td>
                  <td style="border-top: black solid 1px; padding:5px;"> Usage </td>
                  <td style="border-top: black solid 1px; padding:5px;"> List Price </td>
                  <td style="border-top: black solid 1px; padding:5px;"> Discount Price </td>
                  <td style="border-top: black solid 1px; padding:5px;"> * Charge Price </td>
                  <td style="border-top: black solid 1px; padding:5px;"> Usage </td>
                </tr>
                <tr v-for="(item, id) in model.group_list_cache" v-bind:key="id">
                  <td style="border-top: black solid 1px; padding:5px;">{{ item.groupname }} </td>
                  <td style="border-top: black solid 1px; padding:5px;">{{ item.total_usage }} </td>
                  <td style="border-top: black solid 1px; padding:5px;">{{ item.base_price }} </td>
                  <td style="border-top: black solid 1px; padding:5px;">{{ item.discount_price }} </td>
                  <td style="border-top: black solid 1px; padding:5px;">{{ item.total_price }} </td>
                  <td style="border-top: black solid 1px; padding:5px;">
                      <b-badge variant="danger">WEBCastle : {{item.wc_usage | number}} </b-badge>
                      <b-badge variant="warning">WSFinder : {{item.wsf_usage | number}} </b-badge>
                      <b-badge variant="success">WMDS : {{item.wmds_usage | number}} </b-badge>
                      <b-badge variant="info">WFDetector : {{item.wf_usage | number}} </b-badge>
                  </td>
                </tr>
                <tr>
                  <td style="background-color:skyblue; border-top: black solid 1px; padding:5px;"> Total ({{ model.total_group_usage | number }}) </td>
                  <td style="background-color:skyblue; border-top: black solid 1px; padding:5px;"> {{ model.total_usage | number }} </td>
                  <td style="background-color:skyblue; border-top: black solid 1px; padding:5px;">{{ model.total_base_price }} </td>
                  <td style="background-color:skyblue; border-top: black solid 1px; padding:5px;">{{ model.total_discount_price }} </td>
                  <td style="background-color:skyblue; border-top: black solid 1px; padding:5px;">{{ model.total_price }} </td>
                  <td style="background-color:skyblue; border-top: black solid 1px; padding:5px;">
                    {{ model.wc_usage | number}} / {{ model.wsf_usage | number}} / {{ model.wmds_usage | number}} / {{ model.wf_usage | number}}
                  </td>
                </tr>
              </table>
            </b-col>
          </b-row> -->
          <!-- 부분 결제가 있을 경우 히스토리 내역 필요 -->
          <b-row v-if="!loading">
            <b-col md="12">
              <label for=""><h4>Partial Payment History</h4></label>
            </b-col>
            <hr>
            <b-col md="12">
              <!-- TODO : 테이블로 예쁘게 해야 함 -->
              <ul class="list-group">
                <li class="list-group-item" v-for="(item, index) in payment_history" v-bind:key="index" v-bind:class="{ strong: item.hp > 300 }">
                  <small v-if="item && item.payer">
                    <!-- paypal -->
                    <!-- {{item}} -->
                    [Purchased Date:{{item.purchase_units[0].payments.captures[0].create_time | datetime}}]
                    [Company:{{item.payer.email_address}}]
                    [Action:{{item.purchase_units[0].description}}]
                    [Method:{{item.pg}}]
                    [Price:{{item.purchase_units[0].amount.value}}]
                    [Currenty:{{item.purchase_units[0].amount.currency_code}}]
                    [Country:{{item.payer.address.country_code}}]
                  </small>
                  <small v-else>
                    <!-- boot_pay or credit -->
                    [Purchased Date:{{item.purchased_at | datetime}}]
                    [Company:{{item.pg_name}}]
                    [Action:{{item.action}}]
                    [Method:{{item.pg}}]
                    [Price:{{item.price}}]
                    [Currenty:{{'KRW'}}]
                    [Country:{{'KR'}}]
                  </small>
                </li>
              </ul>
            </b-col>
          </b-row>
          <!-- <b-button v-if="!lock" size="sm" variant="success" @click="save"> Save </b-button>
          <b-button v-else size="sm" variant="warning" @click="edit">Edit </b-button> -->
          <!-- <b-button v-if="!lock" size="sm" variant="info" @click="cancel"> Cancel </b-button> -->
          <!-- <b-button size="sm" variant="danger" @click="confirm = true;" v-if="model.id && lock"> Remove </b-button> -->
          <hr v-if="is_show">
          <b-button v-if="is_show" :disabled="model.is_paid" class="float-left m-1" size="sm" variant="info" @click="is_pay = true; model.pay_price = model.total_price"> Manual Payment </b-button>
          <b-button v-if="is_show" size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>

    <router-view></router-view>
    <!-- modal area -->
    <!-- <b-modal title="Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      If this group have user, can't log in after removed
      <br>
      Check first, this  group's user
      <br>
      Would You Like to Remove the group?
    </b-modal> -->
    <b-modal title="Manual Payment"  v-model="is_pay" @ok="pay" ok-variant="warning">
      <!-- <b-checkbox class="ml-3 mt-1" v-model="use_system_credit">Use System Credit (default using partner's credit)</b-checkbox>
      <hr> -->
      <span>
        <!-- Payment can be made with partner's credit or system's credit -->
        Payment by partner's credit
      </span>
      <hr>
      <b-form-input md=12 type="text" id="ph_name" v-model="model.pay_price" ></b-form-input>
    </b-modal>
  </div>
</template>

<script>
import { Api } from '@/service';
import codes from '@/codes';
import reg from '@/reg';
import vSelect from 'vue-select';
import _ from 'lodash';
import moment from 'moment-timezone';
import { Switch as cSwitch } from '@coreui/vue';
import * as htmlToImage from 'html-to-image';
import { saveAs } from 'file-saver';
import { VclFacebook } from 'vue-content-loading';

export default {
  components: {
    cSwitch,
    vSelect,
    VclFacebook
  },
  data : () => {
    return {
      is_pay : false,
      loading : false,
      exporting : false,
      is_show : true,
      so : {
        perPage: 15,
        currentPage: 1, totalRows: 0,
        sk: 'service.name', sv: '', skt: 'Service', opt : {}
      },
      add : false,
      reg,
      confirm : false,
      model : { group : {}, partner : {}, hide_cancel : true, bill_custom : {}, group_list : [], group_list_cache : [] },
      lock : true,
      codes,
      // group with partner
      chainPartner : false,
      syncPartner : false,
      passPartner : false,
      // 일부 거래 기록
      payment_history : []
    }
  },
  computed: {
    // uuid() {
    //   return this.model && this.model.partner && this.model.partner.id ? `${location.hostname.replace('manager.', '')}-${this.model.partner.id}-${moment(this.model.partner).format('YYYY')}` : '-'
    // },
    pay_clear_css() {
      return `z-index:2; position:absolute; top: ${this.model.group_list_cache.length > 10 ? 500 : 440 - (this.exporting ? 60 : 0)}px; left: 40%; transform:rotate(-45deg);`
    }
  },
  methods: {
    async pay() {
      console.log('is_partner_credit?', this.model.pay_price)
      // 파트너 크레딧을 사용하여 빌링 결제

      let rs = await Api.Billing_Call('admin', 'partner.pay', Object.assign({}, { id : this.model.id, amount : this.model.pay_price,  }));
      if(rs.error) {
        return this.$toastr.e('pay failed', rs.reason)
      } else {
        this.$toastr.s('Payment completed')
        this.model = Object.assign({}, this.model, rs.body)

        if(this.model.history) {
            this.payment_history = []
            this.model.history.forEach(r => {
              this.payment_history.push(typeof r == typeof 'string' ? JSON.parse(r) : r)
            });
          }
        this.$emit('refresh')
      }
    },
    async share() {
      try {
        if(this.exporting) { return; }
        this.exporting = true
        this.is_show = false

        console.log("Generating shared image")
        this.$toastr.i("Generating shared image")

        let blob = await htmlToImage.toBlob(document.getElementById('_share'))
        saveAs(blob, `${this.model.partner.username}_invoice_${this.model.apply_date}.png`);
        this.is_show = true
        this.exporting = false

        this.$toastr.s("Shared Image Creation Complete")
      } catch (e) { console.log(e); return this.$toastr.e("export image failed");  }
    },
    reload: function(val) {
      // console.log(val)
      this.model.group_list_cache = _.compact(_.map(this.model.group_list, r => {
        if(r.description == 'canceled') {
          return  !val ? r : ''
        }
        return r

      }))
    },
    edit:function() { this.lock = false },
    cancel: function() {
      if(this.$route.params.id == "add") { this.list(); }
      this.lock = true
      this.$emit('refresh')
    },
    list: function() { this.$router.push({ name: 'InvoicePartner' }); this.$emit('refresh'); },
    remove: function() {
      Api.Manager_Call('invoice.partner', 'delete', { id : this.model.id })
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            return this.$toastr.e('delete', "failed")
          }
          this.list();
        }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    getRowCount () { return this.so.totalRows || 0; },
    async partnerSave() {
      try {
        this.model.partner_id = this.model.partner.id;

        let rs = await Api.Manager_Call('invoice.partner', 'update', Object.assign({}, this.model, { partner : {} }, this.region));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.refresh(rs.body.id);
        } else {
          this.$toastr.e('Save', "failed"); this.refresh();
        }
        this.syncPartner = false;
      } catch (e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); }
    },
    save: async function() {
      try {
        if(!(this.model.groupname || '').trim()) { return this.$toastr.e('Group Name is Require.'); }
        if(!(this.model.service || '').trim()) { return this.$toastr.e('Service is Require.'); }
        if(!(this.model.email || this.model.contact || '').trim()) { return this.$toastr.e('email or contact is Require.'); }
        if(!(this.model.address || '').trim()) { return this.$toastr.e('address is Require.'); }
        // if(!this.model.partner && !this.model.partner_id) { return this.$toastr.e('partner is Require.'); }

        let rs = await Api.Manager_Call('invoice.partner', this.model.id ? 'update' : 'insert', Object.assign({}, this.model));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.refresh(rs.body.id)
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
        this.lock = true;
        this.refresh()
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); this.list()}
    },
    get: async function({ id, tag, invoice_id } = this.$route.params) {
      this.loading = true
      console.log('invoice.partner.detail.vue', 'load item', id, invoice_id);
      if(id === 'add' || tag === 'invoice') { this.model.is_verified = true; this.add = (tag != 'invoice'); this.lock = false; return; }
      else {
        Api.Manager_Call('invoice.partner','detail', { id : id, invoice_id : invoice_id })
          .then(rs => {
            if(rs.error) { return this.$toastr.e("load faild", this.$route.name); }
            this.model = Object.assign({}, this.model, rs.body)
            if(this.model.history) {
              this.payment_history = []
              this.model.history.forEach(r => {
                this.payment_history.push(typeof r == typeof 'string' ? JSON.parse(r) : r)
              });
            }

            // set days
            // set days
            this.model.start = moment(this.model.apply_date, 'YYYYMM').format('YYYY-MM-01')
            this.model.end = moment(this.model.apply_date, 'YYYYMM').format('YYYY-MM-'+moment(this.model.apply_date, 'YYYYMM').daysInMonth())

            this.model.group_list_cache = this.model.group_list
            this.reload(this.model.hide_cancel)

            // if(this.model.group_list_cache) {
            //   this.model.total_usage = _.sumBy(this.model.group_list_cache, x => x.total_usage)
            //   this.model.wc_usage = _.sumBy(this.model.group_list_cache, x => x.wc_usage)
            //   this.model.wsf_usage = _.sumBy(this.model.group_list_cache, x => x.wsf_usage)
            //   this.model.wf_usage = _.sumBy(this.model.group_list_cache, x => x.wf_usage)
            //   this.model.wmds_usage = _.sumBy(this.model.group_list_cache, x => x.wsf_usage)
            // }
            this.loading = false
          })
          .catch(e => {
            console.log(e)
            (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list())
          });
      }
    },
    refresh(id) {
      this.$router.push({ name: 'invoice', params : { id : id ? id : this.$route.params.id } }); this.$emit('refresh');
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('invoice.partner.detail.vue', 'created'); },
  destroyed: function() { console.log('invoice.partner.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('invoice.partner.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
